import { render } from "./SocialShare.vue?vue&type=template&id=6b1835eb&scoped=true"
import script from "./SocialShare.vue?vue&type=script&lang=js"
export * from "./SocialShare.vue?vue&type=script&lang=js"

import "./SocialShare.vue?vue&type=style&index=0&id=6b1835eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1835eb"]])

export default __exports__